import { z } from 'zod'
import { createValidator } from '@mc/form-utils'
import { getGlobalI18nInstance } from '@mc/i18n'

const tf = getGlobalI18nInstance().getFixedT(null, '@mc/next')

export const schema = z.object({
  email: z
    .string({
      required_error: tf('emailCaptureBanner.form.errors.emailIsRequired'),
    })
    .min(1, tf('emailCaptureBanner.form.errors.emailIsRequired'))
    .email(tf('emailCaptureBanner.form.errors.invalidEmail')),
  terms: z.literal(true, {
    errorMap: () => ({ message: tf('emailCaptureBanner.form.errors.terms') }),
  }),
})

export const validateForm = createValidator(schema)
